import { IEntity } from "./id-name";
import { IQueryStrictParams, IRequestParams } from "./page";

export enum AppLogSortField {
  ModifiedAt = "modifiedAt",
  FileSize = "fileSize",
  File = "filename",
  Pod = "pod",
  Container = "container",
}

export interface ILogInfo extends IEntity {
  namespace: string;
  pod: string;
  podId: string;
  podIp: string;
  container: string;
  filename: string;
  nodeName: string;
  nodeIp: string;
  fileSize: number;
  modifiedAt: number;
  realPath: string;
}

export interface ILogInfoListResponse {
  data: ILogInfo[];
  total: number;
  offset: number;
  limit: number;
}

export interface IDownloadRequest {
  namespace: string;
  pod: string;
  podId: string;
  container: string;
  filename: string;
  podIp: string;
}

export interface IAppLogPageRequestParams
  extends IRequestParams<AppLogSortField>, IQueryStrictParams {}
